// @flow
/* eslint-disable camelcase */
import { configStructure } from './constants';
import { getQueryVariable } from './helpers';

// Fill
Number.isInteger =
  Number.isInteger ||
  function(value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  };

/**
 * Compose query string of the current configuration data.
 *
 * @param   {Object} config               Config data and options
 * @param   {Object} config.configOptions Options for the data
 * @param   {Object} config.configData    The current configuration input by user
 *
 * @returns {string}                      Query string or empty.
 */
export const composeQuery = ({
  configOptions,
  configData,
}: {
  configOptions: Object,
  configData: Object,
}) => {
  if (!Object.keys(configOptions).length || !Object.keys(configData).length) {
    return '';
  }

  const urlArray = [];
  let custom_color = '';
  configStructure.every(({ slug }) => {
    const { id } = configData[slug] || {};
    if (slug === 'pa_pinta') {
      ({ custom_color } = configData[slug] || {});
      custom_color = custom_color ? `&color=${custom_color}` : '';
    }
    if (Number.isInteger(id)) {
      urlArray.push(id);
      return true;
    }
    return false;
  });

  return `${urlArray.join(',')}${custom_color}`;
};

/**
 * Parses data from query string.
 *
 * @param   {Object} config               Incl. config options
 * @param   {Object} config.configOptions Options for the data
 *
 * @returns {Object}                      Url-submitted data for the configurator
 */
export const decomposeQuery = ({
  configOptions,
}: {
  configOptions: Object,
}) => {
  const data = {};
  const termIdsString = getQueryVariable('data');
  const colorString = getQueryVariable('color');
  if (!termIdsString.length) {
    return data;
  }

  const termIds = termIdsString.split(',');
  configStructure.every(({ slug }, i) => {
    const targetId = +termIds[i];
    const { name, terms } = configOptions[slug] || {};
    if (!terms || !terms.length || !Number.isInteger(targetId)) {
      return false;
    }

    const entry = terms.find(term => term.id === targetId);
    if (entry) {
      const {
        description,
        id,
        lead_time,
        name: entryName,
        price,
        slug: value,
      } = entry;
      // Create data entry
      data[slug] = {
        description,
        id,
        label: entryName,
        price,
        time: lead_time,
        title: name,
        value,
      };
      // Add custom color if available
      if (
        slug === 'pa_pinta' &&
        value === 'ovilehti_erikoisvari' &&
        colorString
      ) {
        data[slug].custom_color = colorString;
      }
    }

    return entry;
  });

  if (termIds.length !== Object.keys(data).length) {
    alert(
      'Linkin yhteydessä oleva konfigurointi-data on vihreellinen. Konfiguroitu tuote ei välttämättä vastaa alkuperäistä. Suosittelemme aloittamaan konfiguroinnin alusta.'
    );
  }

  return data;
};



// WEBPACK FOOTER //
// ./src/assets/scripts/urlComposer.js